const getCountry = (countryCode) => (country) =>
  country.countryCode === countryCode;

export const findCountryFlag = (countryCode, countries) =>
  countries.find(getCountry(countryCode))?.flag;
